import React from 'react';
import { Mail, Users, Globe } from 'lucide-react';
export const Contact = () => {
  return <div className="pt-20" data-id="element-2699" data-mp="1bscberd8lz51">
      <section className="py-16 bg-secondary/5" data-id="element-2700" data-mp="1br2fo8tux31k">
        <div className="container mx-auto px-4" data-id="element-2701" data-mp="1bugitjachga2">
          <h1 className="text-4xl font-bold text-center text-secondary-dark mb-8" data-id="element-2702" data-mp="1qo1scb3kfm2w">
            Contact Us
          </h1>
          <p className="text-center text-lg text-secondary max-w-3xl mx-auto" data-id="element-2703" data-mp="1lr1l3wuzcda7">
            We'd love to hear from you. Whether you're interested in joining our
            community, exploring partnerships, hosting a Salon in your city, or
            simply learning more about what we do — we're here to connect.
          </p>
        </div>
      </section>
      <section className="py-16" data-id="element-2704" data-mp="12zik1vkin9at">
        <div className="container mx-auto px-4" data-id="element-2705" data-mp="12y7j03iggfne">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-2706" data-mp="f9y13cod4c1j">
            <div className="border border-gray-200 rounded-lg p-6 flex flex-col items-center text-center" data-id="element-2707" data-mp="f83bhl25bvr4">
              <div className="w-12 h-12 bg-secondary/10 rounded-full flex items-center justify-center mb-4" data-id="element-2708" data-mp="a9a9aosb7r69">
                <Mail size={24} className="text-secondary" data-id="element-2709" data-mp="19h0mbxhunfo8" />
              </div>
              <h2 className="text-xl font-bold text-secondary-dark mb-2" data-id="element-2710" data-mp="19exncnypyc7d">
                General Inquiries
              </h2>
              <p className="text-secondary mb-4" data-id="element-2711" data-mp="1j6k6d6hatfko">
                Have a question about The Networking Salon or want to know more
                about our upcoming launches?
              </p>
              <p className="font-medium" data-id="element-2712" data-mp="qi65miyts55f">
                👉 Email us at:{' '}
                <a href="mailto:info@thenetworkingsalon.live" className="text-primary hover:underline" data-id="element-2713" data-mp="qk8z5cz6sgew">
                  info@thenetworkingsalon.live
                </a>
              </p>
            </div>
            <div className="border border-gray-200 rounded-lg p-6 flex flex-col items-center text-center" data-id="element-2714" data-mp="10dzjq6s706pb">
              <div className="w-12 h-12 bg-secondary/10 rounded-full flex items-center justify-center mb-4" data-id="element-2715" data-mp="2bviq2812kps3">
                <Users size={24} className="text-secondary" data-id="element-2716" data-mp="1m73mhshg5cb9" />
              </div>
              <h2 className="text-xl font-bold text-secondary-dark mb-2" data-id="element-2717" data-mp="1m96lv34hohsn">
                Partnerships & Collaborations
              </h2>
              <p className="text-secondary mb-4" data-id="element-2718" data-mp="1w5t5jol2x2t3">
                If you're looking to co-create events, collaborate on
                opportunities, or explore how we can support each other's
                initiatives:
              </p>
              <p className="font-medium" data-id="element-2719" data-mp="13h5h5k519xbb">
                👉 Reach us at:{' '}
                <a href="mailto:partner@thenetworkingsalon.live" className="text-primary hover:underline" data-id="element-2720" data-mp="yjc90lk66t8e">
                  partner@thenetworkingsalon.live
                </a>
              </p>
            </div>
            <div className="border border-gray-200 rounded-lg p-6 flex flex-col items-center text-center" data-id="element-2721" data-mp="18enoj63ek4h7">
              <div className="w-12 h-12 bg-secondary/10 rounded-full flex items-center justify-center mb-4" data-id="element-2722" data-mp="ko9u58xchtjg">
                <Globe size={24} className="text-secondary" data-id="element-2723" data-mp="fpgr6afopkxj" />
              </div>
              <h2 className="text-xl font-bold text-secondary-dark mb-2" data-id="element-2724" data-mp="2rdbwg7jrn33h">
                Host a Salon in Your City
              </h2>
              <p className="text-secondary mb-4" data-id="element-2725" data-mp="2hgqp3fk9xfwh">
                Passionate about building community in your city? We're
                expanding to 30 cities worldwide and would love to hear from
                potential city leads.
              </p>
              <p className="font-medium" data-id="element-2726" data-mp="3a5nu4gzh5g7a">
                👉 Apply or express interest via:{' '}
                <a href="mailto:andre@thenetworkingsalon.live" className="text-primary hover:underline" data-id="element-2727" data-mp="3f3ped58mzlkc">
                  andre@thenetworkingsalon.live
                </a>
              </p>
            </div>
          </div>
          <div className="mt-16 border-t border-gray-200 pt-16" data-id="element-2728" data-mp="3584epdr1ixdr">
            <h2 className="text-2xl font-bold text-center text-secondary-dark mb-8" data-id="element-2729" data-mp="1pohvqkjrd3o4">
              Stay Connected
            </h2>
            <div className="flex justify-center space-x-6" data-id="element-2730" data-mp="1torzrrnzpk0c">
              <a href="https://www.linkedin.com/showcase/thenetworkingsalon/" target="_blank" rel="noopener noreferrer" className="flex items-center border border-gray-200 rounded-lg px-6 py-3 hover:bg-gray-50" data-id="element-2731" data-mp="29z2gf1le3ck2">
                <div className="w-6 h-6 bg-secondary rounded-sm mr-2" data-id="element-2732" data-mp="208r2cm7zrmzg"></div>
                <span data-id="element-2733" data-mp="1va624msqp3b0">LinkedIn</span>
              </a>
              <a href="https://www.instagram.com/thenetworkingsalon/" target="_blank" rel="noopener noreferrer" className="flex items-center border border-gray-200 rounded-lg px-6 py-3 hover:bg-gray-50" data-id="element-2734" data-mp="1v7a4z0opuinm">
                <div className="w-6 h-6 bg-secondary rounded-full mr-2" data-id="element-2735" data-mp="2iypa117vne2k"></div>
                <span data-id="element-2736" data-mp="2j0sakf6noplj">Instagram</span>
              </a>
            </div>
            <p className="text-center text-secondary mt-8" data-id="element-2737" data-mp="2ewc4act4rg5s">
              <span className="font-bold" data-id="element-2738" data-mp="17jagk7evn4c7">📌 Quick Note</span>: We're a global
              initiative with local hubs, so we do our best to respond within 48
              hours. If your inquiry is city-specific, please include your
              location in your message.
            </p>
          </div>
        </div>
      </section>
    </div>;
};